import styled, { css } from 'styled-components';

export const Content = styled.div`
  input {
    ${(props) =>
      props.theme.theme === 'dark' &&
      css`
        color-scheme: dark;
        &::-webkit-calendar-picker-indicator {
          color-scheme: light;
        }
      `}
  }
`;
